import { ValidateCreditCardNumberResult } from "Common/Code/Model/Models";
import { ObjectHelper } from "./ObjectHelper";

export class StringHelper {
  static Empty(): string {
    return '';
  }

  static IsNullOrEmpty(str: string): boolean {
    return str === null || str === '';
  }

  static IsNullOrEmptyOrUndefined(str: string): boolean {
    return str === null || str === '' || str === 'undefined' || str === undefined;
  }

  static StringIs(item: any): boolean {
    return StringHelper.IsNotNullAndEmptyAndUndefined(item);
  }

  static IsNotNullAndEmptyAndUndefined(str: string): boolean {
    return str !== null && str !== '' && str !== "undefined" && str !== undefined;
  }

  static ReplaceAll(str: string, pattern: string, replacement: string): string {
    if (this.StringIs(str)) {
      const resultArr: string[] = str.split(pattern);
      return resultArr.join(replacement);
    }
    return str;
  }

  static EndsWith(str: string, what: string): boolean {
    return str.indexOf(what) > 0;
  }

  static ToDisplay(str: string): string {
    return str || '';
  }
  static ToDateDisplay(str: string): string {
    if (this.StringIs(str)) {
      return moment(str).format('l').replaceAll(" ", "");
    }
    return '';
  }

  static GetLabelsFromFieldConfig(config: any, key: string, locale: string): string {
    let res: string = '';
    if (StringHelper.StringIs(config[key + 'En'])) {
      res = config[key + 'En'];
    }
    if (StringHelper.StringIs(locale) && locale.length >= 2) {
      let lang = locale.charAt(0).toUpperCase() + locale.charAt(1).toLowerCase();
      if (StringHelper.StringIs(config[key + lang])) {
        res = config[key + lang];
      }
    }
    return res;
  }

  static ValidateEmail(email: string): boolean {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  static ValueToEmailAddresses(value: string): Array<emailAddresses.ParsedMailbox> {
    let result: Array<emailAddresses.ParsedMailbox> = [];
    if (StringHelper.StringIs(value)) {
      let emailAddresses1 = emailAddresses({
        input: value,
        //oneResult: null,
        //partial: null,
        //rejectTLD: null,
        rfc6532: true
        //simple: null,
        //startAt: null,
        //strict: null
      });
      console.log(55551, value, 0, emailAddresses1);

      if (ObjectHelper.ObjectIs(emailAddresses1) && ObjectHelper.ArrayIs(emailAddresses1.addresses)) {
        for (let i1 = 0; i1 < emailAddresses1.addresses.length; i1++) {
          if (StringHelper.StringIs(emailAddresses1.addresses[i1].name)) {
            emailAddresses1.addresses[i1].caption = emailAddresses1.addresses[i1].name;
            //=?UTF-8?B?J0phbiBTbWHFvmlua2En?=                       
            if (emailAddresses1.addresses[i1].caption.startsWith('=?') && emailAddresses1.addresses[i1].caption.endsWith('?=')) {
              emailAddresses1.addresses[i1].caption = emailAddresses1.addresses[i1].caption.replace('=?', '').replace('?=', '');
            }
            if (emailAddresses1.addresses[i1].caption.startsWith('UTF-8?B?')) {
              emailAddresses1.addresses[i1].caption = emailAddresses1.addresses[i1].caption.replace('UTF-8?B?', '');
              emailAddresses1.addresses[i1].caption = decodeURIComponent(escape(window.atob(emailAddresses1.addresses[i1].caption)));
            }
            emailAddresses1.addresses[i1].caption = emailAddresses1.addresses[i1].caption.replace(/[']/g, '').replace(/["]/g, '').replace(/[,]/g, '');
          }
        }
        result = JSON.parse(JSON.stringify(emailAddresses1.addresses));
      }
    }
    return result;
  }

  static ValidateCreditCardNumber(cardnumber: string): ValidateCreditCardNumberResult {

    //Error messages
    const ccErrors = [];
    ccErrors[0] = "Unknown card type";
    ccErrors[1] = "No card number provided";
    ccErrors[2] = "Credit card number is in invalid format";
    ccErrors[3] = "Credit card number is invalid";
    ccErrors[4] = "Credit card number has an inappropriate number of digits";
    ccErrors[5] = "Warning! This credit card number is associated with a scam attempt";

    //Response format
    const response = (success, message = null, type = null) => ({
      message,
      success,
      type
    });

    // Define the cards we support. You may add additional card types as follows.

    //  Name:         As in the selection box of the form - must be same as user's
    //  Length:       List of possible valid lengths of the card number for the card
    //  prefixes:     List of possible prefixes for the card
    //  checkdigit:   Boolean to say whether there is a check digit
    const cards = [];
    cards[0] = {
      name: "Visa",
      length: "13,16",
      prefixes: "4",
      checkdigit: true
    };
    cards[1] = {
      name: "MasterCard",
      length: "16",
      prefixes: "51,52,53,54,55",
      checkdigit: true
    };
    cards[2] = {
      name: "DinersClub",
      length: "14,16",
      prefixes: "36,38,54,55",
      checkdigit: true
    };
    cards[3] = {
      name: "CarteBlanche",
      length: "14",
      prefixes: "300,301,302,303,304,305",
      checkdigit: true
    };
    cards[4] = {
      name: "AmEx",
      length: "15",
      prefixes: "34,37",
      checkdigit: true
    };
    cards[5] = {
      name: "Discover",
      length: "16",
      prefixes: "6011,622,64,65",
      checkdigit: true
    };
    cards[6] = {
      name: "JCB",
      length: "16",
      prefixes: "35",
      checkdigit: true
    };
    cards[7] = {
      name: "enRoute",
      length: "15",
      prefixes: "2014,2149",
      checkdigit: true
    };
    cards[8] = {
      name: "Solo",
      length: "16,18,19",
      prefixes: "6334,6767",
      checkdigit: true
    };
    cards[9] = {
      name: "Switch",
      length: "16,18,19",
      prefixes: "4903,4905,4911,4936,564182,633110,6333,6759",
      checkdigit: true
    };
    cards[10] = {
      name: "Maestro",
      length: "12,13,14,15,16,18,19",
      prefixes: "5018,5020,5038,6304,6759,6761,6762,6763",
      checkdigit: true
    };
    cards[11] = {
      name: "VisaElectron",
      length: "16",
      prefixes: "4026,417500,4508,4844,4913,4917",
      checkdigit: true
    };
    cards[12] = {
      name: "LaserCard",
      length: "16,17,18,19",
      prefixes: "6304,6706,6771,6709",
      checkdigit: true
    };

    // Ensure that the user has provided a credit card number
    if (cardnumber.length == 0) {
      return new ValidateCreditCardNumberResult(false, ccErrors[1], null);
    }

    // Now remove any spaces from the credit card number
    // Update this if there are any other special characters like -
    cardnumber = cardnumber.replace(/\s/g, "");

    // Validate the format of the credit card
    // luhn's algorithm
    if (!this.validateCardNumber(cardnumber)) {
      return new ValidateCreditCardNumberResult(false, ccErrors[2], null);
    }

    // Check it's not a spam number
    if (cardnumber == '5490997771092064') {
      return new ValidateCreditCardNumberResult(false, ccErrors[5], null);
    }

    // The following are the card-specific checks we undertake.
    let lengthValid = false;
    let prefixValid = false;
    let cardCompany = "";

    // Check if card belongs to any organization
    for (let i = 0; i < cards.length; i++) {
      const prefix = cards[i].prefixes.split(",");

      for (let j = 0; j < prefix.length; j++) {
        const exp = new RegExp("^" + prefix[j]);
        if (exp.test(cardnumber)) {
          prefixValid = true;
        }
      }

      if (prefixValid) {
        const lengths = cards[i].length.split(",");
        // Now see if its of valid length;
        for (let j = 0; j < lengths.length; j++) {
          if (cardnumber.length == lengths[j]) {
            lengthValid = true;
          }
        }
      }

      if (lengthValid && prefixValid) {
        cardCompany = cards[i].name;
        return new ValidateCreditCardNumberResult(true, null, cardCompany);
      }
    }

    // If it isn't a valid prefix there's no point at looking at the length
    if (!prefixValid) {
      return new ValidateCreditCardNumberResult(false, ccErrors[3], null);
    }

    // See if all is OK by seeing if the length was valid
    if (!lengthValid) {
      return new ValidateCreditCardNumberResult(false, ccErrors[4], null);
    };

    // The credit card is in the required format.
    return new ValidateCreditCardNumberResult(true, null, cardCompany);
  }

  static validateCardNumber(number: string): boolean {
    //Check if the number contains only numeric value  
    //and is of between 13 to 19 digits
    const regex = new RegExp("^[0-9]{13,19}$");
    if (!regex.test(number)) {
      return false;
    }

    return this.luhnCheck(number);
  }

  static luhnCheck(val: string): boolean {
    let checksum = 0; // running checksum total
    let j = 1; // takes value of 1 or 2

    // Process each digit one by one starting from the last
    for (let i = val.length - 1; i >= 0; i--) {
      let calc = 0;
      // Extract the next digit and multiply by 1 or 2 on alternative digits.
      calc = Number(val.charAt(i)) * j;

      // If the result is in two digits add 1 to the checksum total
      if (calc > 9) {
        checksum = checksum + 1;
        calc = calc - 10;
      }

      // Add the units element to the checksum total
      checksum = checksum + calc;

      // Switch the value of j
      if (j == 1) {
        j = 2;
      } else {
        j = 1;
      }
    }

    //Check if it is divisible by 10 or not.
    return (checksum % 10) == 0;
  }

} 